export default "__VITE_ASSET__vCXXgMGk__"